import React, { Component } from 'react';
import ButtonMenuItem from './ButtonMenuItem'; 
import '../Assets/Styles/ButtonMenu.css';

class ButtonMenu extends Component {

  handleOpenModal(target) {
   this.props.openModal(target);
  }

  render() {
    let buttonMenuItems = [];
    buttonMenuItems = this.props.buttonMenu.map((buttonMenuItem) => {
      return(
        <ButtonMenuItem key={buttonMenuItem.label} buttonMenuItem={buttonMenuItem} openModal={this.handleOpenModal.bind(this)} />
      )
    });

    return (
      <nav className="ButtonMenu">
        <div id="groot-sequence"></div>
        <ul>
          {buttonMenuItems}
        </ul>
      </nav>
    );
  }
}

export default ButtonMenu;



// WEBPACK FOOTER //
// ./src/Components/ButtonMenu.js